import React, { Fragment, Component } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import {renderTooltip2, numberFormat} from './../Extras';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { db } from '../../firebase';

const inputStyle = {
	boxShadow: '2px 3px 5px #E7E7E7',
	borderWidth: 0,
}

const textStyle = {
	fontWeight: 'bold',
	fontSize: 18,
	color: '#2a2a2a'
}

const textStyle_ = { 
	fontWeight: 'bold',
	fontSize: 18,
	color: '#2a2a2a',
	borderStyle: 'none',
	backgroundColor:'transparent',
	marginBottom: '15px',
}

class PaymentForm extends Component {
	
	state = {
		send: false,
	};

	displayName = (errors, touched, values) => {
		return (
			<Fragment>
				<div className="row mb-2 mt-3 pl-2">
					<div 
						className="col-12"
						style={textStyle}
					>
						Nombre y Apellido:
					</div>
				</div>
				<input
					type="text"
					name="name"
					className="form-control mb-3"
					style={inputStyle}
					placeholder="Macarena"
					onChange={this.props.changeState}
					required
				/>

				<div className="mb-3 ml-2" style={{color: 'red'}}>
					{errors.name && touched.name && errors.name} 
				</div>
			
			</Fragment>
		);
	};

	displayEmail = (errors, touched, values) => {
		return (
			<Fragment>
				<div className="row mb-2 pl-2">
					<div 
						className="col-12"
						style={textStyle}
					>
						Correo Electrónico:
					</div>
				</div>
				<input
					type="email"
					name="email"
					className="form-control mb-4"
					style={inputStyle}
					placeholder="hola@example.com"
					onChange={this.props.changeState}
					value={this.props.email}
				/>
			
				<div className="mb-3 ml-2" style={{color: 'red'}}>
					{errors.email && touched.email && errors.email} 
				</div>
			</Fragment>
		);
	};

	displayDirection = (errors, touched, values) => {
		return (
			<Fragment>
				<div className="row mb-2 pl-2">
					<div 
						className="col-12"
						style={textStyle}
					>
						Dirección:
					</div>
				</div>

				<textarea
					type="text"
					name="direction"
					className="form-control mb-4"
					style={inputStyle}
					placeholder="Camino el Rosal, 16.789"
					onChange={this.props.changeState}
				/>
				<div className="mb-3 ml-2" style={{color: 'red'}}>
					{errors.direction && touched.direction && errors.direction} 
				</div>
			</Fragment>
		);
	};

	displayCommentary = (errors, touched, values) => {
		return (
			<Fragment>
				<div className="row mb-2 pl-2">
					<div 
						className="col-7"
						style={textStyle}
					>
						Comentarios:
					</div>
				</div>

				<textarea
					type="text"
					name="commentary"
					className="form-control mb-4"
					style={inputStyle}
					placeholder="Agrega Comentario"
					onChange={this.props.changeState}
				/>
				<div className="mb-3 ml-2" style={{color: 'red'}}>
					{errors.commentary && touched.commentary && errors.commentary} 
				</div>
			</Fragment>

		);
	};


	displayOrderSummary = () => {
		const deliveryPrice = parseInt(this.props.deliveryPrice);
		const productPrice = parseInt(this.props.total || 0);
    let totalPrice = (productPrice).toString();
    
		if(this.props.deliveryState === true && this.props.toggleWhatsAppMethod === false){
			totalPrice = (deliveryPrice + productPrice).toString();
		}
		
		return (
			<Fragment>
				<div
					className="col-md-3 offset-md-4 pt-3"
					style={{backgroundColor:'#1d2126'}}
				>	
					{this.props.message === '' ? '' : 'Mensaje Enviado'}

					<div
						style={{...textStyle_, color:'white'}}
					>
						Revisa y Confirma
					</div>

					<div className="d-flex justify-content-end"
						style={{fontSize: 16, color: this.props.shopColor}}
					>
						Resumen
					</div>

					<div className="row my-1">
						<div className="col-6"
							style={{fontSize: 16, color: this.props.shopColor}}
						>
							Subtotal
						</div>
						<div className="col-6 d-flex justify-content-end"
							style={{fontSize: 16, color: this.props.shopColor}}
						>
							{`$ ${numberFormat(this.props.total)}`}
						</div>
					</div>

					{this.props.deliveryState === true && this.props.toggleWhatsAppMethod === false ? 
						<div className="row">
							<div className="col-6"
								style={{fontSize: 16, color: this.props.shopColor}}
							>
								Despacho
							</div>
							
							<div className="col-6 d-flex justify-content-end"
								style={{fontSize: 16, color: this.props.shopColor}}
							>
								{`$ ${numberFormat(this.props.deliveryPrice)}`}
							</div>
						</div> : ''}
					
						<div className="p-3 row mt-2"
							style={{backgroundColor:'#11191e'}}
						>
							<div className="col-6"
								style={{fontSize: 16, color: this.props.shopColor}}
							>
								Total
							</div>

							<div className="col-6 d-flex justify-content-end"
								style={{fontSize: 16, color: this.props.shopColor}}
							>
								{`$ ${numberFormat(totalPrice)}`}
							</div>

						</div>
			  </div>		
			</Fragment>

		)
	}

	sendWhatsApp = async (isSubmitting) => {
		if(!isSubmitting){
			await db.collection('whatsapp').doc()
			.set({
				shoppingCart : this.props.shoppingCart, 
				shopName: this.props.shopName, 
				total: this.props.total, 
				whatsapp: this.props.whatsapp, 
				name: this.props.name, 
				direction: this.props.direction,
				// deliveryCommune: this.props.deliveryCommune,
				// deliveryRegion:this.props.deliveryRegion,
				commentary: this.props.commentary,
				// deliveryPrice: this.props.deliveryPrice,
				// deliveryState: this.props.deliveryState,
				// dispatchTime: this.props.dispatchTime,
				shopDirection: this.props.shopDirection
			})
			.then(() => {
				console.log('listo');
			})
			.catch((err) => {
				console.log(err.message);
			})
		}
		
	}

	displayWhatsAppButton = (url_, deliveryState, isSubmitting) => {
		let disabled_ = true
		if(deliveryState === true){
			disabled_ = !this.props.name 
			|| !this.props.deliveryRegion 
			|| !this.props.deliveryCommune 
			|| !this.props.email
			|| !this.props.direction 
			|| this.props.send === true; 
		} else{
			disabled_ = !this.props.name 
			|| !this.props.email
			|| this.props.send === true; 
		}
		return(
			<div className="row justify-content-center mt-3 mx-2" style={{marginBottom: '70px'}}>
				<button
					className="btn btn-lg"
					style = {{ backgroundColor: '#25D366',borderRadius: '10px', marginBottom: '70px', color: 'white', fontWeight: 'bold' }}
					onClick={() => this.sendWhatsApp(isSubmitting)}
					disabled={isSubmitting}
				>	
					Enviar por WhatsApp		
				</button>
			</div>
		)
		
	}

	render() {
	
		if(this.props.deliveryState === true){
			return (
				<Fragment>
					<Formik
						initialValues={{ 
							email: this.props.email,
							name: this.props.name,
							commentary: this.props.commentary,
							direction: this.props.direction}}

						validate={ () => {
							const errors = {};
							if (!this.props.email) {
								errors.email = 'Campo Requerido';
							} else if (
								!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.props.email)
							) {
								errors.email = 'Invalid email address';
							} 
							if(!this.props.name){
								errors.name = 'Campo Requerido';
							}
							// if(!this.props.commentary){
							// 	errors.commentary = <div className="mt-0 pt-0" style={{color: 'red'}}> Campo Requerido </div>;
							// }

							if(!this.props.direction){
								errors.direction = 'Campo Requerido';
							}
							return errors;
						}}

						onSubmit={(values, { setSubmitting }) => {
							setTimeout(() => {
								window.location.href = this.props.url_;
								setSubmitting(false);
							}, 400);
						}}
					>
						{({
							values,
							errors,
							touched,
							handleBlur,
							handleSubmit,
							isSubmitting,
							/* and other goodies */
						}) => (
							<form onSubmit={handleSubmit}>
								{this.displayName(errors, touched, values)}
								{this.displayEmail(errors, touched, values)}
								{this.displayDirection(errors, touched, values)}
								{this.displayCommentary(errors, touched, values)}
								{this.displayOrderSummary()}

								{this.displayWhatsAppButton(this.props.url_, this.props.deliveryState, isSubmitting)}
							</form>
						)}
					</Formik>
			
				</Fragment>
			)
		}

		else if(this.props.deliveryState === false){
			return (
				<Fragment>
					<div className="row justify-content-end mr-3">
						<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip2(this.props.dispatchTime, this.props.shopDirection)}>
							<IoMdInformationCircleOutline size={25} />
						</OverlayTrigger>
					</div>
					
					<Formik
						initialValues={{ 
							email: this.props.email,
							name: this.props.name,
							commentary: this.props.commentary,
							direction: this.props.direction}}

						validate={ () => {
							const errors = {};
							if (!this.props.email) {
								errors.email = 'Campo Requerido';
							} else if (
								!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.props.email)
							) {
								errors.email = 'Invalid email address';
							} 
							if(!this.props.name){
								errors.name = 'Campo Requerido';
							}
						
							return errors;
						}}

						onSubmit={(values, { setSubmitting }) => {
							setTimeout(() => {
								window.location.href = this.props.url_;
								setSubmitting(false);
							}, 400);
						}}
					>
						{({
							values,
							errors,
							touched,
							handleBlur,
							handleSubmit,
							isSubmitting,
							/* and other goodies */
						}) => (
							<form onSubmit={handleSubmit}>
								{this.displayName(errors, touched, values)}
								{this.displayEmail(errors, touched, values)}
								{this.displayCommentary(errors, touched, values)}

								{this.displayOrderSummary()}

								{this.displayWhatsAppButton(this.props.url_, this.props.deliveryState, isSubmitting)}
							</form>
						)}
					</Formik>
					
					
				</Fragment>
			)
    }
    
		return(
			<Fragment>
			</Fragment>
		)
	}
}

export default PaymentForm;
